import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const userQuery = createAsyncThunk(
  "userQuery",
  async ({ url, data }) => {
    try {
      const response = await axios.post(url, data, {
        // headers: {
        //   authorization: `Basic ${basicAuth}`,
        //   // "Content-Type": "application/json",
        // },
      });
      return response?.data;
    } catch (error) {
      return error?.response;
    }
  }
);

// export const getAllHomeData = createAsyncThunk(
//   "getAllHomeData",
//   async ({ url }) => {
//     try {
//       const response = await axios.get(url, {
//         headers: {
//           //   authorization: `Basic ${basicAuth}`,
//           // authorization: localStorage.getItem("token"),
//           // "Access-Control-Allow-Origin": "*",
//           "Content-Type": "application/json",
//         },
//       });

//       return response?.data;
//     } catch (error) {
//       console.log(error);
//       return error?.response?.data;
//     }
//   }
// );

const homeSlice = createSlice({
  name: "homeSlice",
  initialState: {
    loading: false,
    homeData: null,
  },

  reducers: {},

  // extraReducers: (builder) => {
  //   builder

  //     .addCase(getAllHomeData.pending, (state) => {
  //       state.loading = true;
  //     })
  //     .addCase(getAllHomeData.fulfilled, (state, action) => {
  //       state.loading = false;
  //       state.homeData = action?.payload;
  //     })
  //     .addCase(getAllHomeData.rejected, (state) => {
  //       state.loading = false;
  //     });
  //   //   .addCase(createApiKey.fulfilled, (state, action) => {
  //   //     state.apiKey = action?.payload?.API_Key;
  //   //     state.secureKey = action?.payload?.Secret_Key;
  //   //   });
  // },
});

export default homeSlice.reducer;
